import { combineReducers } from "@reduxjs/toolkit";
import globalReducer from "./slices/global/global.slice";
import lookupReducer from "./slices/lookups/lookups.slice";
import outagesReducer from "./slices/outages/outages.slice";
import versionReducer from "./slices/version/version.slice";

const rootReducer = combineReducers({
  globalState: globalReducer,
  lookups: lookupReducer,
  outages: outagesReducer,
  version: versionReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
